import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, FileText, CheckCircle2 } from "lucide-react";
import { api, API, formatApiErrorDetail } from "../api";

export default function Sign() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [erro, setErro] = useState("");
  const [otp, setOtp] = useState("");
  const [aceite, setAceite] = useState(false);
  const [busy, setBusy] = useState(false);
  const [assinado, setAssinado] = useState(false);

  const load = async () => {
    try { const { data } = await api.get(`/sign/${token}`); setInfo(data); setAssinado(data.estado === "assinada"); }
    catch (e) { setErro(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, [token]); // eslint-disable-line

  const verPdf = () => window.open(`${API}/sign/${token}/pdf`, "_blank");

  const reenviar = async () => {
    try { const { data } = await api.post(`/sign/${token}/reenviar-otp`); toast[data.entregue ? "success" : "message"](data.entregue ? "Codigo reenviado." : "Codigo gerado (verifique a entrega com o remetente)."); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const assinar = async () => {
    if (!aceite) return toast.error("Tem de aceitar para assinar.");
    if (!/^\d{6}$/.test(otp)) return toast.error("Introduza o codigo de 6 digitos.");
    setBusy(true);
    try {
      await api.post(`/sign/${token}/assinar`, { otp: otp.trim(), aceite: true });
      toast.success("Documento assinado com sucesso.");
      setAssinado(true); load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (erro) return <div className="min-h-screen flex items-center justify-center bg-tint/30 text-muted2" data-testid="sign-error">{erro}</div>;
  if (!info) return <div className="min-h-screen flex items-center justify-center text-muted2">A carregar...</div>;

  return (
    <div className="min-h-screen bg-tint/30 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden" data-testid="sign-page">
        <div className="bg-navy text-white px-6 py-5 flex items-center gap-3">
          <ShieldCheck /> <div><div className="font-bold text-lg">Cogniseg - Assinatura</div><div className="text-xs opacity-80">Assinatura eletronica com codigo de uso unico</div></div>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <div className="text-xs text-muted2 uppercase">{info.doc_tipo}</div>
            <div className="text-navy font-bold text-xl">{info.doc_numero} - {info.titulo}</div>
            <div className="text-sm text-muted2 mt-1">Valor: {info.total?.toFixed?.(2)} {info.moeda}</div>
            <div className="text-sm text-muted2">Signatario: {info.signatario_nome}</div>
          </div>
          <button onClick={verPdf} data-testid="sign-view-pdf" className="w-full flex items-center justify-center gap-2 border border-tint rounded-lg py-2.5 text-navy hover:bg-tint/50 transition-colors"><FileText size={16} /> Ver documento (PDF)</button>

          {assinado ? (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center" data-testid="sign-done">
              <CheckCircle2 className="mx-auto text-green-600 mb-2" />
              <div className="font-semibold text-green-800">Documento assinado</div>
              <div className="text-xs text-green-700 mt-1">Assinado em {info.assinado_em ? new Date(info.assinado_em).toLocaleString("pt-PT") : ""}</div>
              <button onClick={verPdf} className="text-blue text-sm underline mt-2" data-testid="sign-view-sealed">Ver documento assinado</button>
            </div>
          ) : (
            <>
              <div className="text-sm text-muted2">Enviamos um codigo de 6 digitos por {(info.canais || []).join(" e ")} para {info.email_mascarado}. Introduza-o para assinar.</div>
              <input value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" maxLength={6}
                placeholder="000000" data-testid="sign-otp"
                className="w-full text-center text-2xl tracking-[0.5em] font-bold px-3 py-3 border border-tint rounded-lg focus:outline-none focus:ring-2 focus:ring-blue" />
              <label className="flex items-start gap-2 text-sm text-navy"><input type="checkbox" checked={aceite} onChange={(e) => setAceite(e.target.checked)} data-testid="sign-accept" className="mt-1" /> Declaro que li e aceito o documento e assino-o eletronicamente.</label>
              <button onClick={assinar} disabled={busy} data-testid="sign-submit" className="w-full bg-blue text-white rounded-lg py-3 font-semibold hover:bg-blue/90 disabled:opacity-50 transition-colors">{busy ? "A assinar..." : "Assinar documento"}</button>
              <button onClick={reenviar} data-testid="sign-resend" className="w-full text-blue text-sm hover:underline">Reenviar codigo</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
